import script from "./EstoqueSaldosOrigemDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./EstoqueSaldosOrigemDashboard.vue?vue&type=script&setup=true&lang=js"

import "./EstoqueSaldosOrigemDashboard.vue?vue&type=style&index=0&id=46b0f773&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46b0f773"]])

export default __exports__